import { gql } from '@apollo/client';

const updateSystemProvider = gql`
  mutation UpdateSystemProvider($variables: SystemProviderUpdate!, $id: Int!) {
    updateSystemProvider(input: $variables, id: $id) {
      id
      name
      recipient_email
      is_active
      openScheduledCount
      createdAt
      updatedAt
    }
  }
`;
export default updateSystemProvider;
